module.exports = __webpack_public_path__ + "img/website-widget.52d22abe.webp";